import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonChartBase } from '../../../common/Models/SkeletonChartBase';
import { LegendPosition } from '../../../common/Models/Enums';
import { getChartAssets } from '../../../common/utils/ChartAssets';

@Component({
  selector: 'skc-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.less']
})
export class ChartComponent extends SkeletonChartBase implements OnInit, OnChanges {
  legendPositionEnum = LegendPosition;
  selectedCustomImage;

  constructor() {
    super();
  }

  ngOnInit() {
    if (!this.customImage) {
      this.selectChartType();
    } else {
      this.selectedCustomImage = this.imageSrc;
    }
  }

  private selectChartType() {
    this.selectedCustomImage = getChartAssets(this.chartType);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customImage && !changes.customImage.firstChange) {
      if (!changes.customImage.currentValue) {
        this.selectChartType();
      } else {
        this.selectedCustomImage = this.imageSrc;
      }
    }
    if (changes.chartType && !changes.chartType.firstChange) {
      if (!this.customImage) {
        this.selectChartType();
      }
    }
  }
}
